









































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import ContactDto from '@/models/Contacts/ContactDto';
import UpdateContactRequest from '@/models/Contacts/UpdateContactRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import PositionDto from '@/models/Positions/PositionDto';

@Component({
    name: 'ContactEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new ContactDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.positions.length === 0) {
        await AgencySettingsModule.getPositions();
      }
      this.entity = JSON.parse(JSON.stringify(ContactDetailsModule.currentContact));
    }
  }

  @Watch('entity.position')
  async onPositionChanged(val: PositionDto, oldVal: PositionDto) {
    if (val) {
      this.entity.jobTitle = val.name;
    }
  }

  get loading() {
    return ContactDetailsModule.loadingDialog;
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateContactRequest()
    request.updatedAt = this.entity.updatedAt;
    request.firstName = this.entity.person.firstName;
    request.lastName = this.entity.person.lastName;
    request.emailAddress = this.entity.emailAddress;
    if (this.entity.position !== null) {
      request.positionId = this.entity.position.id;
    } else {
      request.positionId = undefined;
    }
    request.jobTitle = this.entity.jobTitle;
    request.mobilePhoneNumber = this.entity.mobilePhoneNumber;
    request.otherPhoneNumber = this.entity.otherPhoneNumber;
    request.isAgreedToMarketing = this.entity.isAgreedToMarketing;
    // request.canManageProfile = this.entity.canManageProfile;
    // request.canManageReports = this.entity.canManageReports;
    // request.canManageContacts = this.entity.canManageContacts;
    // request.canManageRoles= this.entity.canManageRoles
    // request.canManageLocations = this.entity.canManageLocations;
    // request.canManageBookings = this.entity.canManageBookings;
    // request.canManageWorkers = this.entity.canManageWorkers;
    // request.canManageTimesheets= this.entity.canManageTimesheets;
    await ContactDetailsModule.editContact(request)
    this.dialog = false;
  }
}
